
<app-price-protection-details *ngIf="entry" [entry]="entry"></app-price-protection-details>
<div class="button" (click)="print()">Print</div>